
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierRseAnswer.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierRseAnswer.ts

import {RseQuestion } from "./RseQuestion";
import {Supplier } from "./Supplier";
import {SupplierRseAnswersIndex } from "./SupplierRseAnswersIndex";
export class SupplierRseAnswer {

  // int Id
  public Id: number=0;

  // int SupplierId
  public SupplierId: number=0;

  // int QuestionId
  public QuestionId: number=0;

  // byte? Answer
  public Answer?: number=null;

  // RseQuestion RseQuestion
  public RseQuestion: RseQuestion=null;

  // Supplier Supplier
  public Supplier: Supplier=null;

  // ICollection<SupplierRseAnswersIndex> SupplierRseAnswersIndexes
  public SupplierRseAnswersIndexes: SupplierRseAnswersIndex[]=[];
}